module.exports = __webpack_public_path__ + "img/drawGift4.508d42bf.png";